import { extractDigits } from "modules/common/services/strings"
import { texts } from "modules/common/texts"
import { childFields, fields } from "modules/spending/employee/models/employer"
import * as yup from "yup"
const { object, string, date } = yup

export const employerLabels = () => ({
  [fields.phone]: "Телефон",
  [fields.email]: "E-mail",
  [fields.login]: "Логин",
  [fields.newPassword]: "Пароль",
  [fields.poohBah]: "Совместитель",
  [fields.birthday]: "День рождения",
  [fields.signDateTo]: "Срок ЭЦП",
  [fields.positionId]: "Должность",
  [fields.position]: "Должность",
  [fields.fireDate]: "Дата увольнения",
  [fields.hireDate]: "Дата приема",
  [fields.contractNumber]: "№ трудового договора",
  [fields.account]: "Данные для перечисления з/п",
  [fields.address]: "Адрес",
  [fields.workSince]: "Стаж с",
  [fields.fired]: "Уволен(а)",
  [fields.isBim]: "BIM",
  [fields.canBeEngineer]: "Доступен как ГИП",
  [fields.salary]: "Оклад",
  [fields.bonus]: "Премия",
  [fields.changeSalary]: "Новый оклад",
  [fields.changeBonus]: "Новая премия",
  [fields.changePositionId]: "Новая должность",
  [fields.changePositionDate]: "С даты",
  [fields.changeHireDate]: "Новая дата приема",
  [fields.canBeReturn]: "Бумеранг",
  [fields.hobby]: "Хобби",
})

const ProfileSchema = () => {
  const labels = employerLabels()

  return object().shape({
    [fields.email]: string().label(labels[fields.email]).notRequired().email(),

    [fields.phone]: string()
      .label(labels[fields.phone])
      .transform(function (val, _) {
        return this.isType(val) && val ? extractDigits(val) : val
      })
      .required()
      .min(7, "Минимум 7 цифр")
      .max(15, "Максимум 15 цифр"),

    [fields.birthday]: date()
      .label(labels[fields.birthday])
      .typeError(texts.messages.incorrectDate())
      .notRequired()
      .nullable(),

    [fields.signDateTo]: date()
      .label(labels[fields.signDateTo])
      .typeError(texts.messages.incorrectDate())
      .notRequired()
      .nullable(),

    [fields.address]: string().label(labels[fields.address]),
    [fields.hobby]: string().label(labels[fields.hobby]).nullable().notRequired(),

    [fields.login]: string()
      .label(labels[fields.login])
      .when(fields.newPassword, {
        is: (pass) => !!pass,
        then: string().required().min(5),
        otherwise: string().notRequired(),
      }),

    [fields.newPassword]: string().label(labels[fields.newPassword]),
  })
}

export default ProfileSchema

export const childLabels = () => ({
  [childFields.name]: "ФИО",
  [childFields.birthday]: "День рождения",
})

export const ChildSchema = () => {
  const labels = employerLabels()

  return object().shape({
    [fields.name]: string().label(labels[fields.name]).required(),

    [fields.birthday]: date()
      .label(labels[fields.birthday])
      .typeError(texts.messages.incorrectDate())
      .notRequired()
      .nullable(),
  })
}
